<template>
  <div
    class="ma-0 pa-0 card-container"
    :style="{ background: dataShow[0]?.background || '#FFFFFF' }"
  >
    <v-card
      flat
      class="card-container lighten-5 pa-0 ma-0"
      :style="{ background: dataShow[0]?.background || '#FFFFFF' }"
    >
      <v-row class="row-container" align="center" justify="center">
        <v-col
          class="d-flex flex-column align-center justify-center text-center"
        >
          <v-img
            :src="dataShow[0].imageUrl || showDefaultImage(dataShow[0].page)"
            width="90%"
            max-width="400"
            max-height="300"
            class="image"
          ></v-img>
          <div
            class="mt-4 pa-0 custom-handle-page ql-editor"
            v-html="dataShow[0]?.message"
          ></div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Error",
  data() {
    return {
      errorStatus: "",
      errorText: "",
      defaultPageHandle: [
        {
          page: "not_in_period",
          pageName: "",
          message: "",
          background: "#F5E6E0",
          imageUrl: null,
        },
        {
          page: "inactive",
          pageName: "",
          message: "",
          background: "#EFF6FF",
          imageUrl: null,
        },
      ],
      dataPageHandle: [],
      dataShow: [],
    };
  },
  created() {
    this.dataPageHandle = this.site.data.page_handle
      ? JSON.parse(this.site.data.page_handle)
      : this.defaultPageHandle;
    const page = this.$route.query.page || "not_in_period";
    this.dataShow = this.dataPageHandle.filter((item) => item.page === page);
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  methods: {
    showDefaultImage(page) {
      if (page === "not_in_period") {
        return require("@/assets/images/page/not_in_period.png");
      } else if (page === "inactive") {
        return require("@/assets/images/page/inactive.png");
      } else {
        return require("@/assets/images/page/not_in_period.png");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .custom-handle-page p {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
